import { twMerge } from 'tailwind-merge'
import definePrimitive from '../../util/definePrimitive'

const Root = definePrimitive({
  name: 'TwoColumLayout',
  element: 'div',
  className: twMerge('grid gap-6 [grid-template-areas:"side""main"] lg:[grid-template-areas:"side_main"] lg:[grid-template-columns:minmax(auto,20rem)_1fr]')
})

const Side = definePrimitive({
  name: 'TwoColumLayoutSide',
  element: 'div',
  className: twMerge('flex flex-col gap-6 [grid-area:side]')
})

const Main = definePrimitive({
  name: 'TwoColumLayoutMain',
  element: 'div',
  className: twMerge('[grid-area:main]')
})

export {
  Root,
  Side,
  Main
}
